(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dv-store-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!window.dvStoreReviewRotationInstalled) {
    window.dvStoreReviewRotationInstalled = true;
    const mount = scope => {
      scope.querySelectorAll('[data-dv-store-reviews][data-surface="home"]').forEach(root => {
        if (root.dataset.rotationMounted) return;
        const grid = root.querySelector('.dv-store-reviews__grid');
        const controls = root.querySelector('[data-review-controls]');
        if (!grid || !controls) return;
        root.dataset.rotationMounted = 'true';
        const cards = Array.from(grid.children);
        const narrow = window.matchMedia('(max-width: 749px)');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        const play = controls.querySelector('[data-review-play]');
        const position = controls.querySelector('[data-review-position]');
        const pageSize = () => narrow.matches || cards.length <= 2 ? 1 : 2;
        let index = Math.floor(Math.random() * Math.max(1, cards.length - pageSize() + 1));
        let paused = reduce.matches;
        let hovering = false;
        let inView = false;
        let timer;
        let pointerX;
        const schedule = () => {
          clearTimeout(timer);
          play.textContent = paused ? play.dataset.play : play.dataset.pause;
          position.setAttribute('aria-live', paused ? 'polite' : 'off');
          if (!root.isConnected || paused || hovering || !inView || document.hidden ||
              root.contains(document.activeElement) || root.querySelector('details[open]') ||
              cards.length <= pageSize()) return;
          timer = setTimeout(() => { move(1); }, 10000);
        };
        const show = () => {
          const size = pageSize();
          index = Math.min(index, Math.max(0, cards.length - size));
          cards.forEach((card, n) => {
            card.hidden = n < index || n >= index + size;
            card.dataset.slot = String(n - index);
          });
          controls.hidden = cards.length <= size;
          root.classList.add('is-rotating');
          position.textContent = position.dataset.label
            .replace('[first]', String(index + 1))
            .replace('[last]', String(Math.min(index + size, cards.length)))
            .replace('[total]', String(cards.length));
          schedule();
        };
        const move = direction => {
          const max = Math.max(0, cards.length - pageSize());
          index = direction > 0 ? (index >= max ? 0 : Math.min(index + pageSize(), max))
            : (index === 0 ? max : Math.max(0, index - pageSize()));
          show();
        };
        const resize = () => {
          root.classList.toggle('is-single-card', pageSize() === 1);
          cards.forEach(card => { card.hidden = false; });
          grid.style.minHeight = Math.ceil(Math.max(0, ...cards.map(card => card.getBoundingClientRect().height))) + 'px';
          show();
        };
        const manual = direction => { paused = true; move(direction); };
        controls.querySelector('[data-review-next]').addEventListener('click', () => manual(1));
        controls.querySelector('[data-review-previous]').addEventListener('click', () => manual(-1));
        play.addEventListener('click', () => { paused = !paused; schedule(); });
        root.addEventListener('mouseenter', () => { hovering = true; schedule(); });
        root.addEventListener('mouseleave', () => { hovering = false; schedule(); });
        root.addEventListener('focusin', () => { paused = true; schedule(); });
        root.addEventListener('focusout', () => setTimeout(schedule, 0));
        grid.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch') return;
          pointerX = event.clientX; paused = true; schedule();
        });
        grid.addEventListener('pointerup', event => {
          if (pointerX === undefined) return;
          const delta = event.clientX - pointerX; pointerX = undefined;
          if (Math.abs(delta) > 60) manual(delta < 0 ? 1 : -1);
        });
        grid.addEventListener('pointercancel', () => { pointerX = undefined; });
        root.addEventListener('toggle', event => {
          if (event.target.open) paused = true;
          schedule();
        }, true);
        const visibility = () => schedule();
        const motion = () => { if (reduce.matches) paused = true; schedule(); };
        document.addEventListener('visibilitychange', visibility);
        narrow.addEventListener('change', resize);
        window.addEventListener('resize', resize);
        reduce.addEventListener('change', motion);
        const observer = new IntersectionObserver(entries => {
          inView = entries[0].isIntersecting; schedule();
        }, { threshold:0.2 });
        observer.observe(root);
        const unload = event => {
          if (!event.target.contains(root)) return;
          clearTimeout(timer); observer.disconnect();
          document.removeEventListener('visibilitychange', visibility);
          document.removeEventListener('shopify:section:unload', unload);
          narrow.removeEventListener('change', resize);
          window.removeEventListener('resize', resize);
          reduce.removeEventListener('change', motion);
        };
        document.addEventListener('shopify:section:unload', unload);
        resize();
      });
    };
    if (window.matchMedia && window.IntersectionObserver) {
      mount(document);
      document.addEventListener('shopify:section:load', event => mount(event.target));
    }
  }
  if (!window.dvStoreReviewEventsInstalled) {
    window.dvStoreReviewEventsInstalled = true;
    const track = (root, action) => {
      try {
        if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event:'dv_store_review_interaction', action, surface:root.dataset.surface });
      } catch (_) {}
    };
    document.addEventListener('click', event => {
      const link = event.target.closest?.('[data-review-action]');
      const root = link?.closest('[data-dv-store-reviews]');
      if (root) track(root, link.dataset.reviewAction);
    });
    document.addEventListener('toggle', event => {
      const detail = event.target;
      if (!detail.matches?.('[data-review-expand]') || !detail.open) return;
      const root = detail.closest('[data-dv-store-reviews]');
      if (root) track(root, 'read_full');
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
